<template>
  <div class="flex">
    <div class="dropdown dropdown-bottom dropdown-start">
      <div tabindex="0" role="button" class="btn btn-link flex items-center gap-0">
        {{ selectedStatus }}
        <vue-feather type="chevron-down" class="h-4 ml-1" />
      </div>
      <div
        tabindex="0"
        class="dropdown-content z-[1] card card-compact w-64 p-2 border border-gray-200 bg-white text-primary-content"
      >
        <div class="card-body">
          <label class="form-control w-full max-w-xs">
            <div class="label mt-0 pt-0">
              <span class="label-text text-gray-600">Customer Status</span>
            </div>
            <select
              v-if="statusFilter"
              v-model="statusFilter.value"
              class="select select-bordered text-gray-800"
              @change="$emit('update-filter', newFilters)"
            >
              <option value="All">All</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    filters: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      statusFilter: null,
    };
  },
  computed: {
    selectedStatus() {
      if (!this.statusFilter || !this.statusFilter.value || this.statusFilter.value === 'All') {
        return 'All Statuses';
      }
      return `Customer Status: ${this.statusFilter.value}`;
    },
    newFilters() {
      return {
        status: this.statusFilter,
      };
    },
  },
  mounted() {
    this.statusFilter = { ...this.filters.find(f => f.key === 'status') };
  },
};
</script>
